import { SurveyApi } from 'api/SurveyApi';

import { accessCodeMapper } from './accessCodeMapper';
import { answerMapper } from './answerMapper';
import { backendApiBeaconClient } from './backendApiBeaconClient';
import { backendReadApiClient, backendWriteApiClient } from './backendApiClient';
import { projectMapper } from './projectMapper';
import { metaMapper } from './metaMapper';

export const surveyApi = new SurveyApi(
  backendReadApiClient,
  backendWriteApiClient,
  backendApiBeaconClient,
  answerMapper,
  projectMapper,
  accessCodeMapper,
  metaMapper
);
